<template>
  <transition
    enter-active-class="animate__animated animate__fadeInLeftBig"
    leave-active-class="animate__animated animate__fadeOutLeftBig"
  >
    <div class="resultlistboard" v-if="!hidedatalist">
      <el-row class="row-bg mx-2 mt-2" justify="start">
        <h6>{{ numtitle }}</h6>
      </el-row>

      <div class="tablecontainer">
        <table class="mytable table">
          <tbody>
            <tr
              :class="{ 'table-primary': currentindex == index }"
              v-for="(item, index) in items.slice(
                (currentPage - 1) * pagesize,
                currentPage * pagesize
              )"
              :key="item.id"
              :id="index"
              @mouseover="myhover(index)"
            >
              <td align="left">
                <el-row>
                  <el-col
                    :span="18"
                    style="vertical-align: middle; margin-top: 10px"
                    ><div>
                      <h2 class="datatitle" :title="item.properties.data_id">
                        {{ index + 1 }}:{{ item.properties.data_id }}
                      </h2>
                    </div></el-col
                  >
                  <el-col :span="1"> </el-col>
                  <el-col :span="3" class="mx-1" style="margin-top: 10px">
                    <h2
                      :class="[
                        item.properties.datastatus === 'online'
                          ? 'online'
                          : 'offline',
                      ]"
                    >
                      {{
                        $t("resultlistmessage." + item.properties.datastatus)
                      }}
                    </h2>
                  </el-col>
                  <el-col :span="1"
                    ><el-checkbox
                      title="Select Product"
                      v-model="checkflag[index]"
                      class="mx-1"
                      size="small"
                  /></el-col>
                </el-row>

                <el-row class="row-bg mt-0" justify="start">
                  <!-- 快视图片 -->
                  <el-col :span="8"
                    ><div>
                      <el-image
                        style="width: 56px; height: 56px"
                        :src="'thumbimg?granuleid=' + item.properties.data_id"
                        class="image"
                      /></div
                  ></el-col>
                  <el-col :span="8"
                    ><div class="grid-content">
                      <tr>
                        <h3>
                          {{ $t("resultlistmessage.satellite") }}:{{
                            item.properties.satellitename
                          }}
                        </h3>
                      </tr>
                      <tr>
                        <h3>
                          {{ $t("resultlistmessage.sensingdate") }}:{{
                            item.properties.startdate
                          }}
                        </h3>
                      </tr>
                    </div></el-col
                  >

                  <!-- 几个图标 -->
                  <el-col :offset="2" class="mt-4" :span="1">
                    <img
                      @click="clickitem(index)"
                      :title="$t('resultlistmessage.viewdata')"
                      v-if="currentindex == index"
                      width="16"
                      height="16"
                      style="cursor: pointer"
                      src="../assets/eye.png"
                  /></el-col>
                  <el-col class="mt-4" :span="1">
                    <button
                      :title="$t('resultlistmessage.zoomtodata')"
                      @click="zoom2item(index)"
                      v-if="currentindex == index"
                      type="button"
                      class="btn aim"
                    />
                  </el-col>
                  <el-col class="mt-4" :span="1">
                    <img
                      @click="ondownloadfile(index)"
                      :title="$t('resultlistmessage.downloaddata')"
                      v-if="currentindex == index"
                      width="16"
                      height="16"
                      style="cursor: pointer"
                      src="../assets/icons8-download-100.png"
                    />
                  </el-col>
                  <el-col class="mt-4" :span="1">
                    <img
                      @click="clickcartitem(index)"
                      :title="carttitle(item.properties.cartflag)"
                      v-if="currentindex == index"
                      width="16"
                      height="16"
                      style="cursor: pointer"
                      :src="cartimgurl(item.properties.cartflag)"
                    />
                  </el-col>
                </el-row>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <el-row justify="space-between mt-2">
        <el-col :span="14">
          <div class="block mt-2 mx-3">
            <el-pagination
              v-model:currentPage="currentPage"
              layout="sizes, prev, pager, next"
              :page-sizes="[10, 25, 50, 100]"
              :page-size="pagesize"
              :pager-count="5"
              :total="itemcount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </el-col>
        <el-col :span="2"></el-col>
        <el-col :span="1">
          <el-tooltip content="Clear Cart" placement="top">
            <el-icon class="mt-2" :size="20" @click="onremoveallfromcart">
              <Delete />
            </el-icon>
          </el-tooltip>
        </el-col>
        <el-col :span="1">
          <el-tooltip content="Bulk Download" placement="top">
            <el-icon class="mt-2" :size="20" @click="onbulkdownload">
              <Download />
            </el-icon>
          </el-tooltip>
        </el-col>
        <el-col :span="1">
          <el-checkbox title="Select All/Deselect All" v-model="selectall" class="mt-1" size="medium" />
        </el-col>
        <el-col :span="1"></el-col>
      </el-row>
    </div>
  </transition>

  <el-dialog
    destroy-on-close="true"
    top="5vh"
    modal="false"
    open-delay="200"
    close-delay="200"
    close-on-click-modal="false"
    close-on-press-escape="false"
    class="mydia"
    append-to-body="true"
    fullscreen="true"
    v-model="scenemapVisible"
    :title="$t('downloadmessage.title')"
  >
    <div style="width: 100vw; height: 100vh">
      <downloadpage @onclosedownloadpage="closepage"></downloadpage>
    </div>
  </el-dialog>
</template>

<script>
import {
  onMounted,
  onUnmounted,
  computed,
  toRefs,
  reactive,
  watch,
  getCurrentInstance,
} from "vue";

//import { Download } from "@element-plus/icons";
import downloadpage from "./downloadpage.vue";
import {
  removefromcart,
  getdatalistincart,
  removeallfromcart,
} from "../js/querydata";
import { ElMessageBox, ElMessage } from "element-plus";
import { downloadfile } from "../js/util";
import { useI18n } from "vue-i18n";

export default {
  components: {
    downloadpage,
    //Download,
  },
  setup() {
    //购物车代码，与resultlistboard有复用代码
    const state = reactive({
      items: [],
      currentPage: 1,
      itemcount: 0,
      pagesize: 10,
      currentindex: 0,
      scenemapVisible: false,
      hidedatalist: true,
      checkflag: [],
      selectall:false
    });
    const { t } = useI18n();
    //购物车标题,根据数据是否在购物车中显示
    const carttitle = () => {
      return t("resultlistmessage.removecart");
    };
    watch(
      () => state.selectall,
      () => {
            for (let i=0;i<state.checkflag.length;i++)
            {
              state.checkflag[i]=state.selectall
            }
      }
    );

    const numtitle = computed(() => {
      var display = t("resultlistmessage.cartdisplay", {
        itemcount: state.itemcount,
      });
      return display;
    });
    //购物车图片
    const cartimgurl = () => {
      return require("../assets/removecart-64.png");
    };

    const { proxy } = getCurrentInstance();
    const app = getCurrentInstance(); //获取根元素
    onUnmounted(() => {
      proxy.$EventBus.off("myscrolltodomid"); //清理注册的事件
      proxy.$EventBus.off("showcartlist");
    });
    onMounted(() => {
      //注册事件
      console.log(t);
      proxy.$EventBus.on("myscrolltodomid", (domid) => {
        document.getElementById(domid).scrollIntoView(false);
        state.currentindex = domid;
      });
      proxy.$EventBus.on("showorhidecart", onshoworhidecart); //显示或关闭购物车面板
    });

    //关闭数据下载页面
    const closepage = () => {
      state.scenemapVisible = false;
    };

    const onremoveallfromcart = () => {
      ElMessageBox.confirm("Want to Clear Cart?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        try {
          removeallfromcart().then((res) => {
            if (res.status == 200) {
              if (res.data.status === "0")
                ElMessage.error({ message: "Remove Product Failed" });
              else {
                onshoworhidecart(true); //重新显示购物车列表,内含重新查询购物车
                proxy.$EventBus.emit("cartchanged"); //发出购物车变化消息
              }
            } else ElMessageBox.alert("Serve error");
          });
        } catch (error) {
          console.log("error");
        }
      });
    };

    //用户点击bulkdownload按钮,本代码设置要下载的数据
    const onbulkdownload = () => {
      let currentPage = state.currentPage;
      let pagesize = state.pagesize;
      var tmpitems = state.items.slice(
        (currentPage - 1) * pagesize,
        currentPage * pagesize
      );
      let bulkdatalist = [];
      for (let i = 0; i < tmpitems.length; i++) {
        if (state.checkflag[i] == true) {
          bulkdatalist.push(tmpitems[i].properties.data_id);
          //console.log(tmpitems[i].properties.data_id);
        }
      }
      if (bulkdatalist.length > 0) {
        let downloadcount = 0; // 计数器
        let jobcount = bulkdatalist.length;
        let intervalId = setInterval(() => {
          downloadfile(bulkdatalist[downloadcount], "yangjin");
          downloadcount++;
          if (downloadcount >= jobcount) {
            clearInterval(intervalId); // 停止定时器
          }
        }, 1000);
      } else {
        ElMessageBox.alert("Please select at least one piece of data");
      }
    };

    //显示结果列表，参数param:查询结果，通过eventbus传递过来
    const onshoworhidecart = (param) => {
      if (typeof param === "boolean") {
        if (param === true) {
          state.hidedatalist = false; //显示购物车面板
          querycart();
        } else {
          state.hidedatalist = true; //关闭购物车
        }
        return;
      }
    };
    const handleSizeChange = (val) => {
      //分页大小变化
      let oldpagesize = state.pagesize;
      state.pagesize = val;
      var newpage = Math.ceil(
        ((state.currentPage - 1) * oldpagesize + state.currentindex) /
          state.pagesize
      );
      state.currentPage = newpage;
      resetcheck();
      showqueryresult(0, "");
    };
    const handleCurrentChange = (val) => {
      state.currentPage = val;
      resetcheck();
      showqueryresult(0, "");
    };

    const myhover = (id) => {
      showqueryresult(id, "");
      state.currentindex = id;
    };
    //用户鼠标单击列表项，在Map上实现关联互动
    const clickitem = (id) => {
      let currentPage = state.currentPage;
      let pagesize = state.pagesize;
      let start, end;
      start = Number((currentPage - 1) * pagesize + id);
      end = Number((currentPage - 1) * pagesize + id + 1);
      var item = state.items.slice(start, end);

      state.scenemapVisible = true;

      var granuleid;
      granuleid = item[0].properties.data_id;

      setTimeout(function () {
        proxy.$EventBus.emit("showscene", granuleid);
        console.log("发送显示景信息");
      }, 300);
    };

    //用户点击购物车按钮出发将数据移出购物车事件
    const clickcartitem = (id) => {
      let index = (state.currentPage - 1) * state.pagesize + id;
      let item = state.items[index];
      ElMessageBox.confirm("want to remove", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        try {
          removefromcart(item.properties.data_id).then((res) => {
            if (res.status == 200) {
              if (res.data.status === "0")
                ElMessage.error({ message: "Remove Product Failed" });
              else {
                onshoworhidecart(true); //重新显示购物车列表,内含重新查询购物车
                proxy.$EventBus.emit("cartchanged"); //发出购物车变化消息
              }
            } else ElMessageBox.alert("Serve error");
          });
        } catch (error) {
          console.log("error");
        }
      });
    };

    function resetcheck() {
      for (let i = 0; i < state.itemcount; i++) state.checkflag[i] = false;
    }
    function showqueryresult(id, method) {
      //发送地图中显示查询结果的消息
      let currentPage = state.currentPage;
      let pagesize = state.pagesize;
      var tmp = state.items.slice(
        (currentPage - 1) * pagesize,
        currentPage * pagesize
      );
      var geom = [];
      for (var i = 0; i < tmp.length; i++) {
        if (id == i) tmp[i].properties.selected = true;
        else tmp[i].properties.selected = false;
        tmp[i].properties.domid = i; //附加的id 用于双向关联
        if (method == "zoom2item") {
          if (id == i) geom.push(tmp[i]);
        } else geom.push(tmp[i]);
      }
      if (method === "zoom2item") proxy.$EventBus.emit("zoom2item", geom);
      else proxy.$EventBus.emit("showqueryframe", geom); //向querymap发送显示结果事件
    }
    //用户在结果列表中点下载
    const ondownloadfile = (id) => {
      let index = (state.currentPage - 1) * state.pagesize + id;
      let item = state.items[index];
      let granuleid = item.properties.data_id;
      let username = app.appContext.config.globalProperties.username;
      if (item.properties.datastatus === "offline") {
        alert(t("resultlistmessage.offlinewaring"));
        return;
      }
      downloadfile(granuleid, username);
    };

    //查询用户购物车
    const querycart = () => {
      try {
        getdatalistincart().then((res) => {
          if (res.status === 200) {
            let param = res.data;
            if (param.status == "1") {
              //有查询结果
              //发送显示查询结果消息，由结果面板捕获消息，param：结果json
              state.items = param.features; //结果赋值到state.items中，state.items通过VUE与界面绑定
              state.itemcount = param.features.length;
              //重置购物车数据选择
              state.checkflag.length = 0;
              for (let i = 0; i < state.itemcount; i++)
                state.checkflag[i] = "false";
              showqueryresult(0, ""); //发送地图中显示查询结果的消息
            }
          }
        });
      } catch (err) {
        console.log(err);
      }
    };

    const zoom2item = (id) => {
      showqueryresult(id, "zoom2item");
      state.currentindex = id;
    };
    return {
      zoom2item,
      clickitem,
      myhover,
      handleCurrentChange,
      handleSizeChange,
      cartimgurl,
      carttitle,
      clickcartitem,
      querycart,
      ondownloadfile,
      closepage,
      onbulkdownload,
      onremoveallfromcart,
      numtitle,
      ...toRefs(state),
      // Download,
    };
  },
};
</script>

<style scoped>
.resultlistboard {
  position: absolute;
  top: 165px;
  left: 25px;
  width: 500px;
  height: 75vh;
  background: #fafafa;
  z-index: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
  opacity: 1;
  transition: 0.5s;
  /* z-index: 2000; */
}
.mytable {
  overflow-x: hidden !important;
  overflow-y: scroll;
  background: white;
}
.tablecontainer {
  overflow: scroll;
  height: 60vh;
  overflow-x: hidden !important;
  scroll-behavior: smooth;
}
h2 {
  font-size: 12px;
  font-weight: bold;
  font-family: sans-serif;
  text-align: center;
}
h3 {
  font-size: 60%;
  font: bold;
  color: #337ab7;
}
.myclose {
  position: absolute;
  right: 15px;
  top: 5px;
}

.myimg {
  position: absolute;
  left: 25px;
  top: 180px;
  /* z-index: 2000; */
  transition: all 0.8s;
}
.darkbackground {
  background: gray;
}
.datatitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all; /* 追加这一行代码 */
}
.online {
  background: green;
  color: white;
  text-align: center;
}
.offline {
  background: red;
  color: white;
  text-align: center;
}
.aim {
  width: 16px;
  height: 16px;
  background: url("../assets/aim-target-svgrepo-com.svg") no-repeat;
}
.animate__animated.animate__fadeInLeftBig {
  --animate-duration: 500ms;
}
.animate__animated.animate__fadeOutLeftBig {
  --animate-duration: 1500ms;
}
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  outline: none;
  box-shadow: none;
}

.borderless-button {
  border: none;
  background-color: transparent;
  color: #333;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s; /* 添加过渡效果，使背景颜色变化平滑 */
  margin-top: 5px; /* 添加上边距 */
  margin-bottom: 5px; /* 添加下边距 */
  font-size: 25px;
}

.el-button:focus {
  /* 按钮激活后的背景颜色不变 */
  background-color: transparent !important;
}
.icon-button .el-icon {
  font-size: 35px !important; /* 调整图标的大小以适应按钮 */
  line-height: 1; /* 可选，用于调整垂直居中 */
}

.borderless-button:hover {
  background-color: transparent; /* 鼠标悬停时改变背景颜色 */
  color: rgb(67, 45, 190); /* 可选，根据需要调整文本颜色 */
  padding: 4px 8px; /* 可选，根据需要调整内边距 */
}
/* 老挝语字体 */
.lwfont {
  font-family: "Saysettha OT", sans-serif;
}

/* 英语字体 */
.enfont {
  font-family: "Arial", sans-serif;
}
</style>
